import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { CalendarClock, Send } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useApi, errMsg } from "@/lib/api";
import { Markdown } from "@/components/ai/Markdown";
import { ExtraRecipients } from "@/components/ai/ExtraRecipients";

export const WeeklyReport = () => {
  const api = useApi();
  const [d, setD] = useState(null);
  const [open, setOpen] = useState(null);
  const [busy, setBusy] = useState(false);
  const load = useCallback(() => api("get", "/ai/epi-reports").then(setD).catch((e) => toast.error(errMsg(e))), [api]);
  useEffect(() => { load(); }, [load]);
  const now = async () => {
    setBusy(true);
    try { const r = await api("post", "/ai/epi-report/send-now"); toast.success(`Rapport envoyé à ${r.recipients.join(", ")}`); load(); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  if (!d) { return null; }
  return (
    <div className="bg-white border border-stone-200 rounded-lg p-6 space-y-4 text-sm" data-testid="ai-weekly-report">
      <div className="flex flex-col sm:flex-row sm:items-center gap-3">
        <CalendarClock className="h-6 w-6 text-[#C2410C] shrink-0" />
        <div>
          <p className="font-medium text-stone-900">Rapport hebdomadaire : {d.schedule}</p>
          <p className="text-stone-600" data-testid="ai-weekly-recipients">7 derniers jours comparés aux 30 derniers, envoyé aux super-admins : {d.recipients.join(", ") || "aucun"}</p>
        </div>
        <Button variant="outline" className="sm:ml-auto" disabled={busy} onClick={now} data-testid="ai-weekly-send-now"><Send className="h-4 w-4 mr-1.5" /> {busy ? "Génération…" : "Envoyer maintenant"}</Button>
      </div>
      <ExtraRecipients value={d.extra_recipients} onSaved={load} />
      {d.reports.length > 0 && (
        <div className="divide-y divide-stone-100 border-t border-stone-100" data-testid="ai-weekly-list">
          {d.reports.map((r) => (
            <div key={r.id} className="py-2">
              <button type="button" className="w-full flex flex-wrap gap-x-4 text-left hover:text-[#C2410C]" onClick={() => setOpen(open === r.id ? null : r.id)} data-testid={`ai-weekly-${r.id}`}>
                <span className="font-medium">{new Date(r.at).toLocaleString("fr-FR")}</span>
                <span className="text-stone-500">{r.trigger}{r.by ? ` par ${r.by}` : ""}</span>
                <span className="text-stone-500">{r.cases_7d} cas / 7 j</span>
                <span className={r.status === "envoyé" ? "text-green-700" : "text-red-700"}>{r.status}{r.recipients?.length ? ` à ${r.recipients.length}` : ""}</span>
              </button>
              {open === r.id && r.markdown && <div className="mt-3 rounded-md bg-stone-50 p-4"><Markdown>{r.markdown}</Markdown></div>}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
